import React from "react";
import { InventoryList } from "../Inventory/Inventory";
import { useTradeStore, useInventoryStore } from "../../store/store";
import './Trade.css'
function Trade() {

    const setShow = useTradeStore((state) => state.setShow);
    const inventory = useInventoryStore((state) => state.inventory);

    const close = () => {
        setShow(false);
    }

    return (
        <div className="modal" style={{ display: "block" }}>
            <div className="modal-content" style={{ width: '900px' }}>
                <div className="tmodal-header">
                    <span className="close" onClick={close}>&times;</span>
                    <h2>Trade</h2>
                </div>
                <div className="modal-body" style={{ width: '100%', padding: '2px 5px' }}>
                    <div className="trade-panel">
                        <div className="trade-inv">
                            <div className="info-header"><p style={{ color: (inventory.invCount > inventory.invMax) ? 'red' : 'white' }}>Inventory ({inventory.invCount} / {inventory.invMax})</p></div>
                            <InventoryList itemList={inventory.itemList} />
                        </div>
                        <div className="">
                        <InventoryList itemList={inventory.itemList} />
                        
                        </div>
                        <div className="">
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="ts-close" onClick={close}>Cancel</button>
                </div>
            </div>
        </div>
    );
}


export default Trade;